<template>
  <div class="card show_more">
    <div class="wrap flx" @click="addProducts">
      <span class="download_ico_arrows"></span>
      <span class="text">Показать еще {{ perPage }} товаров</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShowMoreProducts',
  props: {
    perPage: {
      type: Number,
      default: 20
    }
  },
  methods: {
    addProducts () {
      this.$emit('click:show-more')
    }
  }
}
</script>

<style scoped>

</style>
